module.exports = __webpack_public_path__ + "img/onborad2.1252378f.png";